import { RESET_APP_STATE } from '../stores/redux.store';
import { Action } from '../types';
import { InitialStoreState } from '../utilities/init-app-state';

export const resetAppState = (data: InitialStoreState): Action => ({
  type: RESET_APP_STATE,
  data,
});
